<template>
    <div class="filter">
        <span>Completed between</span>
        <el-date-picker
    		v-model="range"
    		type="daterange"
    		@change="change"
    		format="MMM d, yyyy"
            value-format="timestamp"
    		range-separator="|"
    		class="range-datepicker"
    		start-placeholder="any start date"
    		end-placeholder="any end date">
    	</el-date-picker>
        <!-- <br>
        <span>by</span>
        <el-select
            placeholder="any patient profile"
            v-model="profile"
            @change="change">
            <el-option
                v-for="profile in getProviderProfileList"
                :key="profile.id"
                :label="profile.title"
                :value="profile.id">
            </el-option>
        </el-select>
        <span>for</span>
        -->
        <span> For </span>
        <el-select
            placeholder="any event"
            v-model="event"
            @change="change"
            multiple
            style="width:400px">
            <el-option
                v-for="event in events"
                :key="event.id"
                :label="event.name"
                :value="event.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DateRangePicker from '@/module/component/DateRangePicker'

export default {
    name: "QuestionnaireFilter",

    props: {
        value: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            range: this.value.range || [],
            profile: this.value.profile || [],
            event: this.value.event || []
        }
    },

    created() {
        // this.loadQueriesFromRoute(this.$route.query)
    },

    methods: {
        ...mapActions('content', ['loadContent']),
        change() {
            this.$emit('input', {
                range: this.range,
                profile: this.profile,
                event: this.event
            })
        }
    },

    watch: {
        eventIds(ids) {
            if (Array.isArray(ids)) {
                let missing = ids.filter((id) => (this.getContent('event', id) == null))
                if (missing.length > 0)
                    this.loadContent({ type: 'event', id: missing })
            }
        }
    },

    computed: {
        ...mapGetters('provider', ['getProviderProfileList']),
        ...mapGetters('content', ['getContent']),
        eventIds() {
            if (this.getProviderProfileList)
                return this.getProviderProfileList.flatMap((profile) => profile.event)
            return []
        },
        events() {
            if (this.eventIds)
                return this.eventIds.map((id) => this.getContent('event', id)).filter((e) => e != null)
            return []
        },
        eventList() {
            if(this.getProviderProfileList) {
                return this.getProviderProfileList[0].event
            }
            return []
        },
        formatEventIds() {
            let eventIds = ''
            this.eventId.forEach((id, index) => {
                eventIds += id
                if (index !== this.eventId.length - 1) eventIds += ','
            })
            return eventIds
        }
    },
    components: {
        DateRangePicker
    }
}
</script>

<style scoped lang="scss">
.filter {
    padding: 10px 15px;
    line-height: 50px;

    span {
        color: #913b9c;
        font-weight: 700;
        padding: 0 15px;
    }
}
li.el-select-dropdown__item.selected::after {
    display: none;
}
.select-checkbox {
    height: 20px;
    width: 20px;
    border-radius: 2px;
    border: 1px solid #999;
    position: relative;
    margin-left: -10px;
    margin-top: 7.5px;
    margin-right: 7.5px;
}
.el-icon-check {
    position: absolute;
    top: 10px;
    left: 12px;
    color: #fff;
}
</style>
